import React from 'react';

import Block1Hero from '../Block1Hero';
import Block2Why from '../Block2Why';
import Block2_5Concentration from '../Block2_5Concentration';
import Block4Capacity from '../Block4Capacity';
import Block4_5Targets from '../Block4_5Targets';
import Block5Results from '../Block5Results';
import Block6Implementation from '../Block6Implementation';
import Block7CTA from '../Block7CTA';

export default function HomePage() {
  return (
    <main className="w-full flex flex-col min-h-screen">
      <Block1Hero />
      <Block2Why />
      <Block2_5Concentration />
      <Block4Capacity />
      <Block4_5Targets />
      <Block5Results />
      <Block6Implementation />
      <Block7CTA />
    </main>
  );
}
